import React, { FunctionComponent } from 'react';
import { HeadProvider, Style } from 'react-head';
import { useAppSelector } from 'state/hooks';
import LayoutContent from './LayoutContent';

const Layout: FunctionComponent<React.PropsWithChildren> = () => {
    const brandStyles = useAppSelector((s) => s.site.brandStyles);
    return (
        <>
            <HeadProvider>
                <Style>{brandStyles}</Style>
            </HeadProvider>
            <LayoutContent />
        </>
    );
};

export default Layout;
